<!-- IMPORT WRAPPER — embeds your existing BulkImportComponent -->
<div class="onboarding-import-wrapper">
<app-bulk-import
  [validator]="validator"
  [close]="false"
  (importClose)="onImportDone()">
</app-bulk-import>
</div>